// extracted by mini-css-extract-plugin
module.exports = {"hamburger":"Hamburger_hamburger__2GULD","part":"Hamburger_part__3eVpX","altPart":"Hamburger_altPart__DJUfs","open":"Hamburger_open__2Y_ST"};